import { createAction, props } from '@ngrx/store';

export enum LocationActions {
  SELECTED_LOCATION = '[Location] Selected Location',
  CLEAR_LOCATION = '[Location] Selected Location',
  SET_SEARCH_LOC_RESULTS = '[Location] Set search results',
  SET_LOC_FILTERS = '[Location] Set location filters',
  CLEAR_SEARCH_RESULTS = '[Location] Clear Search Locations'
}

export const SetLocationAction = createAction(
  LocationActions.SELECTED_LOCATION,
  props<{ selectedLocation: any }>()
);

export const ClearLocationAction = createAction(LocationActions.CLEAR_LOCATION);

export const SetSearchLocationResultsAction = createAction(
  LocationActions.SET_SEARCH_LOC_RESULTS,
  props<{ searchResults: any }>()
);

export const ClearSearchResultsAction = createAction(
  LocationActions.CLEAR_SEARCH_RESULTS,
);

export const SetLocFiltersAction = createAction(
  LocationActions.SET_LOC_FILTERS,
  props<{ searchFilters: any }>()
);
